// extracted by mini-css-extract-plugin
module.exports = {"Stats":"Stats_Stats__2Yzne","statWrap":"Stats_statWrap__1YWFx","panelWrapper":"Stats_panelWrapper__3Dlg5"};